<script setup lang="ts">
import type { SPOT } from '@/types'

const props = defineProps<{
  isOpen: boolean
  spots: SPOT[]
  selectedSpot: SPOT
}>()

const emits = defineEmits<{
  (e: 'close'): void
  (e: 'selected', spotId: SPOT['id']): void
}>()

const router = useRouter()
const deviceToken = useStorage('device-token', '')

const hasMultipleSpots = computed(() => props.spots.length > 1)

const headerClasses = computed(() => (hasMultipleSpots.value ? '' : '!p-0'))

const handleOpenSettingsPage = (spotId: SPOT['id']) => {
  router.push(`/settings?spot_id=${spotId}&device_token=${deviceToken.value}`)
}
</script>

<template>
  <AppDialog
    :is-open="isOpen"
    :can-close="true"
    :has-close-button="hasMultipleSpots"
    :header-classes="headerClasses"
    @close="emits('close')"
  >
    <template v-if="hasMultipleSpots" #title>
      <p class="text-gray-500">Choose Your Spot</p>
    </template>
    <template #content>
      <div v-if="hasMultipleSpots">
        <AppList
          v-for="spot in spots"
          :key="spot.id"
          name="spot"
          :checked="spot.selected"
          :label="spot.name"
          :spot="spot"
          @selected="emits('selected', spot.id)"
        />
      </div>
      <div
        class="flex w-full items-center justify-center gap-1 bg-brand-dark p-4 text-white"
        @click="handleOpenSettingsPage(selectedSpot.id)"
      >
        <AppiconBell class="h-5 w-5 fill-white" />
        <p>Settings & Notifications</p>
      </div>
    </template>
  </AppDialog>
</template>
